import React, { useEffect, useState } from 'react'
import { Bar } from '@ant-design/plots';
import moment from 'moment';
import queryKeys from 'common/queryKey';
import { useFetch } from 'hooks/useFetch';
import { connect } from 'react-redux';
import { getClientid } from 'redux/selectors';
import { Spin } from 'antd';
import DetailsModal from 'organisms/DetailsModal';

const educationLevels = ["Bachelor", "Diploma", "Certificate", "Master", "Doctorate"];

function QualificationByGradecode({ value, clientid }) {

    const [dataList, setDataList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [plotData, setPlotData] = useState("");


    const { getQualificationByGradeCode, getConfiguration } = queryKeys;

    const payload = {
        method: "qualificationByGradeCode",
        parameters: {
            startDate: value?.date ? moment(value?.date).format("YYYY-MM-DD") : "",
            endDate: value?.end_date ? moment(value?.end_date).format("YYYY-MM-DD") : "",
            managingOffice: value?.managingoffice || [],
            competencyQC: value?.competencyQC || [],
            officesupervisor: value?.officesupervisor || ""
          }
    };

    const payloadString = JSON.stringify(payload);
    const { key, url } = getQualificationByGradeCode(clientid, payloadString);

    const { data, isLoading, refetch } = useFetch(
        key,
        url,
        {
            enabled: !!clientid,
        },
        payload
    );

    const { key: configurationKey, url: configurationUrl } = getConfiguration();
    const { data: configurationData, isLoading: isConfigurationLoading } = useFetch(
        configurationKey,
        configurationUrl,
        {
            enabled: !!clientid,
        }
    );

    useEffect(() => {
        const gradeConfigurations = configurationData?.response?.items?.filter(
            (item) => item.configurationName === "chargeout" && item.jobgradecode
        );
        if (!gradeConfigurations) return;

        const grades = [
            ...new Map(
                gradeConfigurations.map((item) => [item.jobgradecode, item])
            ).values(),
        ].sort((first, second) =>
            String(first.jobgradecode).localeCompare(String(second.jobgradecode))
        );
        const educationCounts = (data?.response?.qualificationByGradeCode || []).reduce(
            (counts, user) => {
                user.educationdetails?.forEach(({ awarded }) => {
                    const countKey = `${user.grade}-${awarded}`;
                    counts[countKey] = (counts[countKey] || 0) + 1;
                });
                return counts;
            },
            {}
        );

        setDataList(
            grades.flatMap(({ jobgradecode }) =>
                educationLevels.map((name) => ({
                    xValue: jobgradecode,
                    name,
                    listItem: [jobgradecode],
                    Count: educationCounts[`${jobgradecode}-${name}`] || 0,
                }))
            )
        );
    }, [configurationData, data]);

    const plotClick = () =>{
        if(plotData?.data?.data){
            const filterData = data?.response?.qualificationByGradeCode?.filter(
                (item) => {
                  return (
                    item.educationdetails.some(
                      (ed) => ed.awarded === plotData.data.data.name
                    ) && plotData.data.data.listItem?.includes(item?.grade)
                  );
                }
              );
    
              setTableData(filterData);
              setIsModalVisible(true);
        } 
}

useEffect(()=>{
    if(plotData !== ""){
    plotClick();
    }
},[plotData])

    const config = {
        data: dataList,
        animation: false,
        isStack: true,
        xField: 'Count',
        yField: 'xValue',
        seriesField: 'name', // Group by the 'name' field
        colorField: 'name',
        groupField: 'name', // Group by the 'name' field
        label: false,
        color: ['#D6A5FF', '#FAC49C', '#00685F', '#F26B6B', '#9CD3FA'],
        onReady: (plot) => {
            plot.on("plot:click", (evt) => {
              setPlotData(evt);
            });
          },
        xAxis: {
            tickInterval: 4,
            grid: {
                line: {
                    style: {
                        opacity: 0
                    }
                }
            }
        },
    };
    return (
        <>
        <h6 className="mt-2">Qualification By Grade code:</h6>
        <div className='box-container'>
            <Spin spinning={isLoading || isConfigurationLoading}>
                <Bar {...config} />
            </Spin>
        </div>
        <DetailsModal
        isopen={isModalVisible}
        isCancel={() => setIsModalVisible(false)}
        tabledata={tableData}
      />
        </>
        
    )
}

const mapStateToProps = (state) => ({
    clientid: getClientid(state),
});

export default connect(mapStateToProps, null)(QualificationByGradecode);
